import { render, staticRenderFns } from "./browseReplies.vue?vue&type=template&id=35b3f5a9&scoped=true&"
import script from "./browseReplies.vue?vue&type=script&lang=js&"
export * from "./browseReplies.vue?vue&type=script&lang=js&"
import style0 from "./browseReplies.vue?vue&type=style&index=0&id=35b3f5a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3f5a9",
  null
  
)

export default component.exports